import { render, staticRenderFns } from "./ispTask.vue?vue&type=template&id=861b973c"
import script from "./ispTask.vue?vue&type=script&lang=js"
export * from "./ispTask.vue?vue&type=script&lang=js"
import style0 from "./ispTask.vue?vue&type=style&index=0&id=861b973c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports